export const pickerMessages = {
  "selection.requiredError": [
    "请选择一个选项",
    "選択肢を選んでください",
    "Choose an option"
  ],
  "selection.remove": [
    "移除{label}",
    "{label}を削除",
    "Remove {label}"
  ],
  "selection.addMore": [
    "继续添加…",
    "さらに追加…",
    "Add more…"
  ],
  "selection.clear": [
    "清除{label}",
    "{label}をクリア",
    "Clear {label}"
  ],
  "selection.value": [
    "选择项",
    "選択項目",
    "Selection"
  ],
  "selection.minQuery": [
    "输入至少 {count} 个字符开始搜索",
    "{count}文字以上入力して検索",
    "Type at least {count} characters to search"
  ],
  "selection.loading": [
    "正在搜索…",
    "検索中…",
    "Searching…"
  ],
  "selection.failed": [
    "搜索失败，请重试",
    "検索できませんでした。再試行してください",
    "Search failed. Please retry"
  ],
  "selection.results": [
    "{count} 个候选项",
    "{count}件の候補",
    "{count} options"
  ],
  "selection.noResults": [
    "没有匹配项，试试其他关键词",
    "一致する候補がありません。別の語句を試してください",
    "No matching options. Try another query"
  ],
  "selection.retryKey": [
    "也可以按 Enter 重试",
    "Enterキーでも再試行できます",
    "You can also press Enter to retry"
  ],
  "selection.limit": [
    "最多选择 {count} 项",
    "最大{count}件まで選択できます",
    "Select up to {count} options"
  ],
  "selection.selectedCount": [
    "已选择 {count} 项",
    "{count}件選択済み",
    "{count} selected"
  ],
  "selection.dismissHint": [
    "Esc 关闭",
    "Escで閉じる",
    "Esc to close"
  ],
  "selection.searchPlaceholder": [
    "输入以搜索…",
    "入力して検索…",
    "Type to search…"
  ],
  "selection.choosePlaceholder": [
    "请选择…",
    "選択してください…",
    "Choose an option…"
  ],
  "common.retry": [
    "重试",
    "再試行",
    "Retry"
  ]
} as const;
